<div>
  <img src="../../assets/logobakup.png" alt="" width="300px">
  <hr>
  <h1>Welcome To TinCan</h1>
  <h2 *ngIf="!authS.isAuthenticated()">Please log in to access the dashboard. The login link is in the top right</h2>
</div>
